export const API_URL = process.env.REACT_APP_API_URL;
export const MEETING_DOMAIN = process.env.REACT_APP_MEETING_DOMAIN;
console.log("API_URL", API_URL);

export const LANGUAGES: string[] = [
  'English',
  'Hindi',
];